//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ReportDescriptor } from '@react/reporting/ReportDescriptors'
import { logOT } from '@shared/loggingShared'
import { ReportDefinitionCTO } from '@shared/ReportDefinitionCTO'
import { EthAddr } from '@shared/SchemaTypes'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

export const reportDefinitionPut = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  reportDefinition: Partial<ReportDefinitionCTO>
): Promise<ReportDefinitionCTO> => {
  if (!reportDefinition.reportUuid) {
    reportDefinition.reportUuid = uuidv4()
  }

  logOT.debug('reportDefinitionPut APX', `${serverApiBaseUrl}/reportDefinition`, reportDefinition)

  const r = await axios.put(`${serverApiBaseUrl}/reportDefinition`, reportDefinition, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })
  const data = r.data
  logOT.debug('reportDefinitionPut', data)
  return data.results
}

export const reportDefinitionsGet = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  accountAddr: EthAddr
): Promise<ReportDefinitionCTO[]> => {
  const r = await axios.get(`${serverApiBaseUrl}/reportDefinitions?accountAddr=${accountAddr}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })
  const data = r.data

  const profiles = data.results
  return profiles
}

export async function reportDefinitionsForShape(
  serverApiBaseUrl: string,
  restAPIKey: string,
  accountAddr: EthAddr,
  reportDescriptor: ReportDescriptor
): Promise<ReportDefinitionCTO[]> {
  const definitions = await reportDefinitionsGet(serverApiBaseUrl, restAPIKey, accountAddr)
  const defs = definitions.filter((d) => d.dataShape === reportDescriptor.dataShape)

  return defs
}
